import { render } from "./GetAllPostulants.vue?vue&type=template&id=13c2cde0&scoped=true"
import script from "./GetAllPostulants.vue?vue&type=script&lang=js"
export * from "./GetAllPostulants.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13c2cde0"]])

export default __exports__